export interface IMatterports {
  title: string;
  embed_id: string;
  id?: string;
  type?: string;
}

